/* istanbul ignore file */
import { UntypedFormGroup } from '@angular/forms';

import { Color } from '../../../../models/color';

import { GeoJsonFile, MapContextLayer, PresetStyleColorSelection, ShapefileInfo } from '../../../../models';
import { MapElementColor } from '../../../../shared/enums';

export class MapContextLayersLogicServiceModel {
    availableStrokeColors: PresetStyleColorSelection[] = [];
    availableFillColors: PresetStyleColorSelection[] = [];
    colorObjectByContextLayerColor: ColorObjectByContextLayerColor;
    form: UntypedFormGroup = new UntypedFormGroup({});
    isInEditMode = false;
    contextLayerEditing: MapContextLayer | null = null;
    editedLayerUploadChanged = false;
    fileUploadProperties: ShapefileInfo = new ShapefileInfo();
    geoJsonFile: GeoJsonFile = new GeoJsonFile();
    contextLayers: MapContextLayer[] = [];
    isCreatingNewLayer = false;
    hasLoadedAllLayers = false;
    fetchingAllLayers = false;
    previewContextLayer: MapContextLayer | null = null;
    previewContextLayerFeatureIndex: number | null = null;
    isFormSaving = false;
}

export type ColorObjectByContextLayerColor = Record<MapElementColor, Color>;
